import React from 'react';

function ErrorPage(props) {
    return (
        <div>
            Unable to Join Room
        </div>
    );
}

export default ErrorPage;